import imgMap from 'assets/images/eventBoatRacing/mapLao.png'
import { useEffect, useRef, useState } from 'react'
// import imgSpin from 'assets/images/eventBoatRacing/imgSpin.png'
import { useTranslation } from 'react-i18next'
import i18n from 'i18n'
import { animateValue, handleRunBoat, setPositionBoat } from 'utils/helpers'
import { listPositionsMap } from 'utils/contanst'
import { mediaQueryPoint, useMediaQuery } from 'utils/hooks'
import { rotate } from 'utils/hooks/awardRotate'
import { useQuery } from 'react-query'
import {
	getStepEventBoatRacingQuery,
	useStartSpinEventBoatRacing,
} from 'dataLayer/game'
import { getUserQuery } from 'dataLayer/user'
import { useDispatch } from 'react-redux'
import { reloadHeader, showSnackbar } from 'store/actions'
import GoldPopupModal from 'components/Modal/PopupModal/GoldPopupModal'
import BuffPopupModal from 'components/Modal/PopupModal/BuffPopupModal'
import BigGoldPopupModal from 'components/Modal/PopupModal/BigGoldPopupModal'
import SpinResultPopupModal from 'components/Modal/PopupModal/SpinResultPopupModal'
import NoTurnPopupModal from 'components/Modal/PopupModal/NoTurnPopupModal'
import { useNavigate } from 'react-router-dom'
import { PATHS } from 'config/routes'
import PenaltyPopupModal from 'components/Modal/PopupModal/PenaltyPopupModal'
import FinishPopupModal from 'components/Modal/PopupModal/FinishPopupModal'
import imgSpinLa from 'assets/images/eventBoatRacing/imgSpinLa.png'
import imgSpinVi from 'assets/images/eventBoatRacing/imgSpinVi.png'
import imgSpinEn from 'assets/images/eventBoatRacing/imgSpinEn.png'
import imgFooter from 'assets/images/eventBoatRacing/imgfootSpin.png'
import imgBoat from 'assets/images/eventBoatRacing/imgBoatBgrHome.png'
import imgBird from 'assets/images/eventBoatRacing/imgBird.png'
import { getData, setData } from 'utils/localStorage'

function BoatRacingHome() {
	const refSpin = useRef(null)
	const refStep = useRef(null)
	const navigate = useNavigate()
	const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoint.md}px)`)
	const isMobileSm = useMediaQuery(`(max-width: ${mediaQueryPoint.sm}px)`)
	const { t } = useTranslation()
	const [imgSpin, setImgSpin] = useState(imgSpinLa)
	const [isBlockedSpin, setIsBlockedSpin] = useState(false)
	const { data: user, isLoading: isLoadingUser } = useQuery(getUserQuery())
	const { data: dataBoatRacing, refetch: refetchStep } = useQuery(
		getStepEventBoatRacingQuery(),
	)
	const [statePopupGold, setStatePopupGold] = useState({
		show: false,
		coin: 0,
	})
	const [statePopupBuff, setStatePopupBuff] = useState({
		show: false,
		type: 'blessing',
		step: 0,
	})
	const [statePopupObstacle, setStatePopupObstacle] = useState({
		show: false,
		type: 'rock',
	})
	const [statePopupSpecial, setStatePopupSpecial] = useState({
		show: false,
		coin: 0,
	})
	const [statePopupMoreTurn, setStatePopupMoreTurn] = useState({
		show: false,
		data: [],
	})
	const [showPopupFinish, setShowPopupFinish] = useState(false)
	const [statusStep, setStatusStep] = useState(null)
	const [openPopupNoTurn, setOpenPopupNoTurn] = useState(false)
	const dispatch = useDispatch()

	const afterSpinSuccess = data => {
		if (data) {
			const dataPopupApi = data.listResultSpin[data.listResultSpin.length - 1]
			rotate(refSpin.current, {
				angle: 0,
				animateTo: data.randomAngle + 1800,
				duration: data.type === 1 ? 4000 : 6000,
				callback: function () {
					setIsBlockedSpin(false)
					if (data.type === 1) {
						setStatusStep(null)
						if (dataPopupApi.type === 'GOLD') {
							setStatePopupGold({
								show: true,
								coin: dataPopupApi.awardReceived,
							})
						}
						if (dataPopupApi.type === 'GOOD_LUCK') {
							setStatePopupBuff({
								show: true,
								type: 'blessing',
								step: 0,
							})
						}
						if (dataPopupApi.type === 'SPECIAL_AWARD') {
							setStatePopupSpecial({
								show: true,
								coin: dataPopupApi.awardReceived,
							})
						}
						if (dataPopupApi.type === 'STEP') {
							setStatePopupBuff({
								show: true,
								type: 'step',
								step: dataPopupApi.awardReceived,
							})
							setStatusStep(data)
						}
					}
					if (data.type === 10) {
						setStatusStep(data)
						let newListAward = data.listResultSpin.map((it, index) => {
							if (it.type === 'SPECIAL_AWARD') {
								it.label = t('event.boat_racing.popup.reward.gold').replace(
									'_GOLD_',
									it.awardReceived || 5000,
								)
							}
							if (it.type === 'GOOD_LUCK') {
								it.label = t('event.boat_racing.popup.reward.blessing')
							}
							if (it.type === 'STEP' && it.awardReceived > 1) {
								it.label = t('event.boat_racing.popup.reward.steps').replace(
									'_STEP_',
									it.awardReceived || 0,
								)
								if (it.coinReceived && it.coinReceived > 0) {
									it.label = `${t(
										'event.boat_racing.popup.reward.steps',
									).replace('_STEP_', it.awardReceived || 0)} (${it.coinReceived
										} Gold)`
								}
							}
							if (it.type === 'STEP' && it.awardReceived === 1) {
								it.label = t('event.boat_racing.popup.reward.steps')
									.replace('_STEP_', it.awardReceived || 0)
									.replace('steps', 'step')
							}
							if (it.type === 'GOLD') {
								it.label = `${it.awardReceived} Gold`
							}
							return it
						})
						setStatePopupMoreTurn({
							show: true,
							data: newListAward,
						})
					}
				},
			})
		}
	}
	const afterSpinError = error => {
		setIsBlockedSpin(false)
		console.log(error)

		if (error.errorCode === '271') {
			setOpenPopupNoTurn(true)
		} else {
			dispatch(showSnackbar(true, error.message, 'error'))
		}
	}

	const { mutate: startSpin } = useStartSpinEventBoatRacing(
		afterSpinSuccess,
		afterSpinError,
	)
	useEffect(() => {
		refetchStep().then(res => {
			if (res && res.isSuccess) {
				setPositionBoat(listPositionsMap[res.data.step], isMobile, isMobileSm)
			}
		})
	}, [user, isMobile, isMobileSm])
	useEffect(() => {
		// statusStep xử lý ở đây
		if (dataBoatRacing) {
			let stepOld = getData('step_old')
			if (stepOld) {
				let numberCheck = Math.abs(dataBoatRacing.step - stepOld)
				if (numberCheck > 0 && numberCheck <= 3) {
					animateValue(refStep.current, stepOld, dataBoatRacing.step, 350)
				}
				if (numberCheck > 3 && numberCheck <= 6) {
					animateValue(refStep.current, stepOld, dataBoatRacing.step, 700)
				}
				if (numberCheck > 6 && numberCheck < 15) {
					animateValue(refStep.current, stepOld, dataBoatRacing.step, 1400)
				}
				if (numberCheck > 15) {
					animateValue(refStep.current, stepOld, dataBoatRacing.step, 3000)
				}
			}
			setData('step_old', dataBoatRacing.step)
		}
	}, [dataBoatRacing?.step])

	useEffect(() => {
		const currentLanguage = i18n.language
		if (currentLanguage === 'vi') {
			setImgSpin(imgSpinVi)
		} else if (currentLanguage === 'en') {
			setImgSpin(imgSpinEn)
		} else {
			setImgSpin(imgSpinLa)
		}
		const handleLanguageChange = lng => {
			if (lng === 'vi') {
				setImgSpin(imgSpinVi)
			} else if (lng === 'en') {
				setImgSpin(imgSpinEn)
			} else {
				setImgSpin(imgSpinLa)
			}
		}
		i18n.on('languageChanged', handleLanguageChange)

		return () => {
			i18n.off('languageChanged', handleLanguageChange)
		}
	}, [])

	useEffect(() => {
		if (!statePopupBuff.show && statusStep) {
			refetchStep().then(async res => {
				if (res && res.isSuccess) {
					let stepOld = getData('step_old')
					let stepRun = +stepOld + statusStep.listResultSpin[0].awardReceived
					for (let i = stepOld + 1; i <= stepRun; i++) {
						let isStop = false
						let numberPosition = i
						if (i === stepRun) {
							isStop = true
						}
						if (i >= 50) {
							numberPosition = i - 50
						}
						await handleRunBoat(
							listPositionsMap[numberPosition],
							isMobile,
							isMobileSm,
							isStop ? afterRunBoat : () => { },
							isStop,
						)
					}
				}
			})
		}
	}, [statePopupBuff.show])

	const handleBuyMore = () => {
		navigate(PATHS.SHOP_PAGE)
	}
	const handleStartSpin = turn => {
		if (!isBlockedSpin) {
			setIsBlockedSpin(true)
			startSpin({ type: turn })
		}
	}
	const afterRunBoat = () => {
		if (
			statusStep.isGold ||
			statusStep.isThatLuang ||
			statusStep.isWave ||
			statusStep.isRock ||
			statusStep.isEndRound
		) {
			if (statusStep.isGold) {
				setStatePopupGold({
					show: true,
					coin: statusStep.coinReceived,
				})
			}
			if (statusStep.isThatLuang) {
				setStatePopupSpecial({
					show: true,
					coin: 5000,
				})
			}
			if (statusStep.isWave) {
				setStatePopupObstacle({
					show: true,
					type: 'wave',
				})
			}
			if (statusStep.isRock) {
				setStatePopupObstacle({
					show: true,
					type: 'rock',
				})
			}
			if (statusStep.isEndRound) {
				setShowPopupFinish(true)
			}
		}
	}
	const handleOnHideBuffPopup = () => {
		setStatePopupBuff({
			show: false,
			type: 'blessing',
			step: 0,
		})
		if (statePopupBuff.type === 'blessing') {
			refetchStep()
		}
	}
	const afterRunBoatResult = () => {
		dispatch(reloadHeader(new Date() * 1 + 1))
		if (statusStep.isEndRound) {
			setShowPopupFinish(true)
		}
		setStatePopupMoreTurn({
			show: false,
			data: [],
		})
	}
	const handleClosePopupResult = () => {
		setStatePopupMoreTurn({
			show: false,
			data: [],
		})
		refetchStep().then(async res => {
			if (res && res.isSuccess) {
				let stepOld = getData('step_old')
				if (stepOld !== res.data.step) {
					let stepRun = res.data.step
					if (stepOld > res.data.step) {
						if (stepOld - res.data.step > 3) {
							stepRun = res.data.step + 50
						} else {
							stepRun = stepOld
							stepOld = stepRun
						}
					}
					for (let i = stepOld + 1; i <= stepRun; i++) {
						let isStop = false
						if (i === stepRun) {
							isStop = true
						}
						let numberPosition = i
						if (i >= 50) {
							numberPosition = i - 50
						}
						await handleRunBoat(
							listPositionsMap[numberPosition],
							isMobile,
							isMobileSm,
							isStop ? afterRunBoatResult : () => { },
							isStop,
						)
					}
				}
			}
		})
	}

	return (
		<div className="boat-racing-home">
			<div className="boat-racing-home-round">
				<div className="round">{`${t('event.boat_racing.home.round')} ${dataBoatRacing?.round || 0
					}`}</div>
				<div ref={refStep} className="step">{`${t(
					'event.boat_racing.home.step',
				)} ${dataBoatRacing?.step || 0}`}</div>
			</div>
			<div className="boat-racing-home-map">
				<div className="boat-racing-home-map-content">
					<img
						srcset={`${imgMap} 2x`}
						alt="map"
						className="boat-racing-home-map-content-img-map"
					/>
					<div
						id="boat-running-event"
						className="boat-racing-home-map-content-img-boat"
					/>
					{isMobile ? (
						<>
							<img
								// srcset={`${imgBoat} 2x`}
								src={imgBoat}
								alt="boat"
								className="icon-bgr-boat"
							/>
							<img
								srcset={`${imgBird} 2x`}
								alt="bird"
								className="icon-bgr-bird icon-1"
							/>
							<img
								srcset={`${imgBird} 2x`}
								alt="bird"
								className="icon-bgr-bird icon-2"
							/>
							<img
								srcset={`${imgBird} 2x`}
								alt="bird"
								className="icon-bgr-bird icon-3"
							/>
						</>
					) : null}
				</div>
			</div>
			<div className="boat-racing-home-spin">
				<div className="boat-racing-home-spin-box">
					<img
						id="img_spin"
						ref={refSpin}
						src={imgSpin}
						alt="lucky-spin"
						className="boat-racing-home-spin-box-img"
					/>
					<img
						src={imgFooter}
						alt="footer-spin"
						className="boat-racing-home-spin-box-img-footer"
					/>
				</div>
				<div className="boat-racing-home-spin-number">
					{`${t('event.boat_racing.home.number_spin')} ${dataBoatRacing?.totalSpinLeft || 0
						}`}
				</div>
				<button onClick={handleBuyMore} className="btn-more-spins">
					{t('event.boat_racing.home.get_more_spins')}
				</button>
			</div>
			<div className="boat-racing-home-box-btn-spin">
				<div onClick={() => handleStartSpin(1)} className="btn-spin one-spin">
					<span>{t('event.boat_racing.home.turn').replace('_TURN_', 1)}</span>
					<span className="btn-spin-footer" />
				</div>
				<div onClick={() => handleStartSpin(10)} className="btn-spin">
					<span>
						{t('event.boat_racing.home.turn')
							.replace('_TURN_', 10)
							.replace('Turn', 'Turns')}
					</span>
					<span className="btn-spin-footer" />
				</div>
			</div>
			<img src={imgBoat} alt="boat" className="icon-bgr-boat-footer" />
			<div className="boat-racing-home-warning">
				<div className="icon-warning" />
				<div className="text-warning">
					{t('event.boat_racing.home.warning')}
				</div>
			</div>
			<GoldPopupModal
				show={statePopupGold.show}
				coin={statePopupGold.coin}
				onHide={() => {
					refetchStep()
					dispatch(reloadHeader(new Date() * 1 + 1))
					setStatePopupGold({ show: false, coin: 0 })
				}}
			/>
			<BuffPopupModal
				show={statePopupBuff.show}
				type={statePopupBuff.type}
				step={statePopupBuff.step}
				statusStep={statusStep}
				onHide={statusStep => handleOnHideBuffPopup(statusStep)}
			/>
			<BigGoldPopupModal
				show={statePopupSpecial.show}
				coin={statePopupSpecial.coin}
				onHide={() => {
					refetchStep()
					dispatch(reloadHeader(new Date() * 1 + 1))
					setStatePopupSpecial({
						show: false,
						coin: 0,
					})
				}}
			/>
			<SpinResultPopupModal
				show={statePopupMoreTurn.show}
				data={statePopupMoreTurn.data}
				onHide={() => {
					handleClosePopupResult()
				}}
			/>
			<NoTurnPopupModal
				show={openPopupNoTurn}
				onHide={() => setOpenPopupNoTurn(false)}
				handlePlay={() => navigate(PATHS.HOME_PAGE)}
				handleBuyPackage={() => navigate(PATHS.SHOP_PAGE)}
			/>
			<PenaltyPopupModal
				show={statePopupObstacle.show}
				type={statePopupObstacle.type}
				onHide={() => {
					setStatePopupObstacle({
						show: false,
						type: 'rock',
					})
					handleRunBoat(
						listPositionsMap[dataBoatRacing.step],
						isMobile,
						isMobileSm,
						() => { },
						true,
					)
				}}
			/>
			<FinishPopupModal
				show={showPopupFinish}
				onHide={() => {
					refetchStep()
					setShowPopupFinish(false)
				}}
			/>
		</div>
	)
}

export default BoatRacingHome
